import './App.css';
import { useEffect, useState } from 'react';
import { fetchInstagramPosts } from './services/instagramService';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { fetchEvents } from './services/eventService';

function App() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventsError, setEventsError] = useState(null);

  useEffect(() => {
    // AOS animasyon kütüphanesini başlat
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const instagramPosts = await fetchInstagramPosts();
        setPosts(instagramPosts);
        setError(null);
      } catch (error) {
        console.error('Instagram posts fetch error:', error);
        setError('Instagram gönderileri yüklenirken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const eventData = await fetchEvents();
        setEvents(eventData);
        setEventsError(null);
      } catch (error) {
        console.error('Events loading error:', error);
        setEventsError('Etkinlikler yüklenirken bir hata oluştu.');
      } finally {
        setEventsLoading(false);
      }
    };

    loadEvents();
  }, []);

  // Navbar scroll efekti
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Menüyü aç/kapa
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Menü açıkken scroll'u engelle
    document.body.classList.toggle('menu-open', !isMenuOpen);
  };

  // Menü linkine tıklandığında menüyü kapat
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  // Component unmount olduğunda class'ı temizle
  useEffect(() => {
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, []);

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-content">
          <div className="logo">
            <span className="logo-text">SET</span>
            <span className="logo-dot"></span>
          </div>
          
          <button 
            className={`menu-button ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#home" onClick={closeMenu}>Ana Sayfa</a></li>
            <li><a href="#activities" onClick={closeMenu}>Etkinlikler</a></li>
            <li><a href="#gallery" onClick={closeMenu}>Galeri</a></li>
            <li><a href="#about" onClick={closeMenu}>Hakkımızda</a></li>
            <li>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfH6aZ9sescSsEC9zU1G7_YCpWLmr-JWivrvYVYNSn6IEtdGw/viewform" className="nav-cta" onClick={closeMenu}>
            Aramıza Katıl
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <main>
        <section className="hero" id="home">
          <div className="hero-content">
            <div className="hero-text-content">
              <h1 className="glowing-text">
                Kütahya'nın En Aktif
                <br />
                <span className="highlight">Öğrenci Topluluğu</span>
              </h1>
              <p className="hero-subtitle">
                Sosyal Aktiviteler, Geziler ve Unutulmaz Anılar
              </p>
              <div className="hero-buttons">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfH6aZ9sescSsEC9zU1G7_YCpWLmr-JWivrvYVYNSn6IEtdGw/viewform" className="cta-button primary">
              <span>Üye Ol</span>
              <i className="fas fa-arrow-right"></i>
              </a>
                <button className="cta-button secondary">
                  <i className="fas fa-calendar-alt"></i>
                  <span>Etkinliklerimiz</span>
                </button>
              </div>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">1000+</span>
                  <span className="stat-label">Üye</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100+</span>
                  <span className="stat-label">Etkinlik</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Gezi</span>
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="hero-image-grid">
              <img src="https://i.imgur.com/8Rtf98M.jpeg" alt="Etkinlik 1" className="grid-image image1" width="400" height="400" />
              <img src="https://i.imgur.com/3kcdubT_d.webp?maxwidth=1520&fidelity=grand" alt="Etkinlik 2" className="grid-image image2" width="400" height="400" />
              <img src="https://i.imgur.com/29N19bX_d.webp?maxwidth=760&fidelity=grand" alt="Etkinlik 3" className="grid-image image3" width="400" height="400" />
</div>

              <div className="floating-badges">
                <div className="badge badge1">
                  <i className="fas fa-users"></i>
                  <span>Aktif Topluluk</span>
                </div>
                <div className="badge badge2">
                  <i className="fas fa-calendar-check"></i>
                  <span>Haftalık Etkinlikler</span>
                </div>
                <div className="badge badge3">
                  <i className="fas fa-map-marked-alt"></i>
                  <span>Şehir Gezileri</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-scroll-indicator">
            <div className="scroll-text">Aşağı Kaydır</div>
            <div className="scroll-icon">
              <i className="fas fa-chevron-down"></i>
            </div>
          </div>
        </section>

        <section className="instagram-section" id="gallery">
          <div className="section-header" data-aos="fade-up">
            <h2>Instagram'da Biz</h2>
            <p className="section-subtitle">Son etkinliklerimiz ve paylaşımlarımız</p>
            <a 
              href="https://www.instagram.com/dpuset" 
              target="_blank" 
              rel="noopener noreferrer"
              className="instagram-follow-button"
            >
              <i className="fab fa-instagram"></i>
              Bizi Takip Et
            </a>
          </div>
          
          {loading ? (
            <div className="loading-events">
              <div className="loading-spinner">
                <i className="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          ) : (
            <div className="instagram-container">
              <div className="posts-grid">
                {posts.slice(0, 6).map((post, index) => (
                  <a
                    key={post.id}
                    href={post.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="post-card"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div className="post-image">
                      <img 
                        src={post.media_url} 
                        alt={post.caption?.slice(0, 30) || 'Instagram post'} 
                        loading="lazy"
                      />
                      <div className="post-overlay">
                        <div className="post-stats">
                          <span>
                            <i className="fas fa-heart"></i>
                            {post.likes || 0}
                          </span>
                          <span>
                            <i className="fas fa-comment"></i>
                            {post.comments || 0}
                          </span>
                        </div>
                        <div className="post-content">
                          <p className="post-caption">
                            {post.caption?.length > 100 
                              ? post.caption.substring(0, 100) + '...' 
                              : post.caption}
                          </p>
                          <span className="read-more">
                            Daha fazla gör <i className="fas fa-arrow-right"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          )}
        </section>

        <section className="activities-section" id="activities">
          <div className="section-header">
            <h2>Neler Yapıyoruz?</h2>
            <p className="section-subtitle">Her hafta yeni bir etkinlik!</p>
          </div>
          <div className="features-grid">
            <div className="feature-card" data-aos="fade-up">
              <i className="fas fa-users feature-icon"></i>
              <h3>Sosyal Etkinlikler</h3>
              <p>Kahve buluşmaları, film geceleri ve eğlence dolu organizasyonlar</p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="100">
              <i className="fas fa-mountain feature-icon"></i>
              <h3>Şehir Gezileri</h3>
              <p>Türkiye'nin dört bir yanına kültür ve eğlence gezileri</p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="200">
              <i className="fas fa-palette feature-icon"></i>
              <h3>Sanat Etkinlikleri</h3>
              <p>Resim, müzik ve tiyatro atölyeleri</p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="300">
              <i className="fas fa-futbol feature-icon"></i>
              <h3>Spor Aktiviteleri</h3>
              <p>Turnuvalar, maçlar ve spor organizasyonları</p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="400">
              <i className="fas fa-graduation-cap feature-icon"></i>
              <h3>Kişisel Gelişim</h3>
              <p>Seminerler, workshoplar ve kariyer etkinlikleri</p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="500">
              <i className="fas fa-handshake feature-icon"></i>
              <h3>Sosyal Sorumluluk</h3>
              <p>Topluma faydalı projeler ve yardım kampanyaları</p>
            </div>
          </div>
        </section>

        <section className="social-responsibility" id="responsibility">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">#BizimMahalle 🤝🏻❤</span>
            <h2>Sosyal Sorumluluk Projemiz</h2>
            <p className="section-subtitle">Gençler olarak topluma değer katıyoruz</p>
          </div>

          <div className="responsibility-content">
            <div className="responsibility-image" data-aos="fade-right">
              <img 
                src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800" 
                alt="Mahallede Birlik Projesi" 
              />
              <div className="partners">
                <div className="partner">
                  <img 
                    src="https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?w=200" 
                    alt="SET Logo" 
                  />
                  <span>SET</span>
                </div>
                <div className="partner">
                  <img 
                    src="https://images.unsplash.com/photo-1586769852044-692d6e3703f0?w=200" 
                    alt="Muhtarlık Logo" 
                  />
                  <span>Servi Mahalle Muhtarlığı</span>
                </div>
                <div className="partner">
                  <img 
                    src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=200" 
                    alt="MEŞEM Logo" 
                  />
                  <span>MEŞEM</span>
                </div>
              </div>
            </div>

            <div className="responsibility-info" data-aos="fade-left">
              <div className="info-content">
                <h3>Projemiz Hakkında</h3>
                <p>
                  Sosyal Etkinlik Topluluğu, Servi Mahalle Muhtarlığı ve Çıraklık Eğitim Merkezi(MEŞEM) 
                  işbirliğinde organize ettiğimiz projemizle Kütahya'daki ihtiyaç sahiplerine ulaşıyoruz.
                </p>
                <ul className="project-features">
                  <li>
                    <i className="fas fa-home"></i>
                    <span>Ev alışverişi desteği</span>
                  </li>
                  <li>
                    <i className="fas fa-hands-helping"></i>
                    <span>Yaşlı vatandaşlara yardım</span>
                  </li>
                  <li>
                    <i className="fas fa-heart"></i>
                    <span>Gönüllü destek ağı</span>
                  </li>
                </ul>

                <div className="join-project">
                  <h4>Gönüllü Olmak İster misiniz?</h4>
                  <p>
                    Mahallede Birlik Projesi'ne katılarak topluma değer katın. 
                    Yaşlı komşularımıza yardım eli uzatmak ve gönüllü ağımıza 
                    katılmak için hemen başvurun!
                  </p>
                  <div className="upcoming-events-preview">
                    {eventsLoading ? (
                      <div className="loading-events">
                        <div className="loading-spinner">
                          <i className="fas fa-circle-notch fa-spin"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="events-list">
                        {events.map(event => (
                          <div key={event.id} className="event-preview">
                            <div className="event-date">
                              <span className="date">{event.date}</span>
                            </div>
                            <div className="event-info">
                              <div className="event-header">
                                <h5>{event.title}</h5>
                              </div>
                              <p>{event.description}</p>
                              <div className="event-meta">
                                <span>
                                  <i className="fas fa-map-marker-alt"></i> 
                                  {event.details.location}
                                </span>
                                <span>
                                  <i className="fas fa-users"></i> 
                                  {event.details.capacity}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <a href="#volunteer" className="join-button">
                    <span>Gönüllü Ol</span>
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="impact-stats">
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Yardım Edilen Aile</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Gönüllü</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">0</span>
                  <span className="stat-label">Kurumsal Partner</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-waves">
          <div className="wave wave1"></div>
          <div className="wave wave2"></div>
          <div className="wave wave3"></div>
        </div>
        <div className="footer-content">
          <div className="footer-sections">
            <div className="footer-section main-section">
              <div className="footer-logo">
                <span className="logo-text">SET</span>
                <span className="logo-dot"></span>
              </div>
              <p className="footer-description">
                Kütahya DPÜ'nün en aktif öğrenci topluluğu. 
                Sosyal aktiviteler, geziler ve unutulmaz anılar için bizimle tanışın!
              </p>
              <div className="footer-stats">
                <div className="stat">
                  <span className="stat-number">1000+</span>
                  <span className="stat-label">Üye</span>
                </div>
                <div className="stat">
                  <span className="stat-number">100+</span>
                  <span className="stat-label">Etkinlik</span>
                </div>
                <div className="stat">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Gezi</span>
                </div>
              </div>
            </div>
            
            <div className="footer-section links-section">
              <h3>Hızlı Bağlantılar</h3>
              <div className="footer-links-grid">
                <div className="links-column">
                  <h4>Keşfet</h4>
                  <ul>
                    <li><a href="#activities">Etkinlikler</a></li>
                    <li><a href="#gallery">Galeri</a></li>
                    <li><a href="#about">Hakkımızda</a></li>
                    <li><a href="#join">Üyelik</a></li>
                  </ul>
                </div>
                <div className="links-column">
                  <h4>İletişim</h4>
                  <ul>
                    <li><a href="mailto:dpuset@gmail.com">E-posta</a></li>
                    <li><a href="tel:905531183336">İletişim</a></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="footer-section contact-section">
              <h3>Bize Ulaşın</h3>
              <p className="address">
                <i className="fas fa-map-marker-alt"></i>
                Dumlupınar Üniversitesi<br />
                Merkez Kampüs, Kütahya
              </p>
              <div className="social-links">
                <a href="https://www.instagram.com/dpuset" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="social-link instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="social-link twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="social-link whatsapp">
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p>&copy; 2025 SET Topluluğu. Tüm hakları saklıdır.</p>
              <div className="footer-bottom-links">
                <a href="#privacy">Gizlilik Politikası</a>
                <a href="#terms">Kullanım Şartları</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
